export const getInitialFilterValues = () => ({
  statuses: [],
  // this is not selected as a regular filter, it is set in the special account select bar
  // selectedSellerAccounts: [],
  selectedSourceMarketplace: null,
  timeLeft: null,
  itemPerformanceRank: '',
  outOfStockDays: null,
  numberOfOrdersFrom: '',
  numberOfOrdersTo: '',
  numberOfCompetitorsFrom: '',
  numberOfCompetitorsTo: '',
  listDateFrom: '',
  listDateTo: '',
  daysWithoutSale: '',
  destinationPriceFrom: '',
  destinationPriceTo: '',
  sourcePriceFrom: '',
  sourcePriceTo: '',
  profitFrom: '',
  profitTo: '',
  profit: true,
  itemViewsFrom: '',
  itemViewsTo: '',
  itemWatchersFrom: '',
  itemWatchersTo: '',
  template: '',
  discoveryId: '',
  notMonitoring: false
});
